import { IonInput as IonicIonInput, IonIcon } from '@ionic/react'
import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme'

export const DrawerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const Title = styled.div`
  font-size: 18px;
  line-height: 18px;
  font-weight: 500;
  margin-bottom: 16px;
`

export const InputWrapper = styled.div`
  position: relative;
  input {
    margin-right: 25px !important;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
`

export const InputIcon = styled(IonIcon)`
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 2;
`

export const IonInput = styled(IonicIonInput)`
  && {
    --background: ${myPalette.white.main};
    --border-color: ${myPalette.blue.lightSteelBlue};
    --border-width: 1px !important;
    --padding-start: 16px;
    --border-radius: 6px;
    --highlight-color-focused: ${myPalette.blue.main};
    --highlight-color: ${myPalette.blue.main};
    --highlight-color-valid: ${myPalette.blue.main};
    --color: ${myPalette.blue.lightSteelBlue};

    --highlight-color-invalid: ${myPalette.red.main};

    input {
      color: ${myPalette.midnightBlue.main};
    }
  }
  &&:hover,
  &&:focus,
  &&:active {
    --border-color: ${myPalette.blue.main};
    --color: ${myPalette.blue.main};
  }
`

export const CheckBoxWrapper = styled(DrawerWrapper)`
  margin-bottom: 46px;
`

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  padding: 0 16px;
  gap: 8px;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 16px;
  z-index: 2;
`
